import {
  Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
} from "@/components/ui/select";

// Reusable car dropdown built on shadcn Select (no native <option>, avoids the
// "<span> cannot be a child of <option>" instrumentation warning + matches the dark theme).
const CarSelect = ({ cars, value, onSelect, testid, placeholder = "Vyberte vozidlo…" }) => (
  <Select value={value || undefined} onValueChange={(v) => onSelect(v, cars.find((c) => c.id === v))}>
    <SelectTrigger className="input-dark" data-testid={testid}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent className="bg-zinc-900 border-white/10 text-zinc-200">
      {cars.map((c) => (
        <SelectItem key={c.id} value={c.id} className="focus:bg-white/10 focus:text-white" data-testid={`${testid}-option-${c.id}`}>
          {c.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default CarSelect;
